<template>
  <a-row :gutter="24">
    <a-col :xs="24" :md="8">
      <a-form-item label="Email Notification Contact Group">
        <a-select
          v-model="contactGroupModel"
          size="large"
          class="full-w"
          placeholder="Select contact group"
          show-search
          :loading="loading"
          :filter-option="filterOption"
        >
          <a-select-option :value="null">
            No email notifications
          </a-select-option>
          <a-select-option
            v-for="group in contactGroups"
            :key="String(group.value)"
            :value="group.value"
          >
            {{ group.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-col>
  </a-row>
</template>

<script>
export default {
  name: 'AutoFinetuneContactGroupField',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    contactGroups: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    contactGroupModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    filterOption(input, option) {
      const children = option.componentOptions && option.componentOptions.children;
      const label = children && children[0] && children[0].text;
      return String(label || '')
        .toLowerCase()
        .includes(String(input || '').toLowerCase());
    }
  }
};
</script>

<style scoped>
.full-w {
  width: 100%;
}
</style>
